'use strict';

import axios from 'axios';
import { customEvent } from '@jspartials/general-utils';

const selector = {
  wrapper: '.js-login-and-sign-up-content-wrapper'
};

const element = {
  wrapper: null
};

const initLoginAndSignUp = () => {
  axios
    .get(globalVariables.endpoint.showLogin, {
      params: {
        isDrawerContext: true
      }
    })
    .then((response) => {
      const { data = {} } = response;
      const { htmlText = '' } = data;
      const { globalVariables = {} } = data;
      const { customer = {} } = globalVariables;
      const customerIsLoggedIn = customer.isLoggedIn || false;

      element.wrapper = document.querySelector(selector.wrapper) || null;

      if (element.wrapper) {
        // Paint the login and signup form in the DOM
        element.wrapper.innerHTML = htmlText;

        // Dispatch the custom event to notify that the login and signup form is loaded
        document.dispatchEvent(
          new CustomEvent(customEvent.loginAndSignupLoaded)
        );

        // Dispatch the custom event to notify that the QR generator is loaded
        if (customerIsLoggedIn) {
          document.dispatchEvent(
            new CustomEvent(customEvent.qrGeneratorLoaded)
          );
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

export { initLoginAndSignUp };
